var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 19.0623L11.75 0.312256L14.25 0.312256L14.25 19.0623L11.75 19.0623Z",
    fill: "#00842F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8839 19.7489C13.3958 20.237 12.6043 20.237 12.1162 19.7489L5.60729 13.24L7.37506 11.4722L13.0001 17.0972L18.6251 11.4722L20.3928 13.24L13.8839 19.7489Z",
    fill: "#00842F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 16.7498V25.7451C3.28884 25.7481 3.33059 25.7498 3.375 25.7498H22.625C22.6694 25.7498 22.7112 25.7481 22.75 25.7451V16.7498H25.25V26.3569C25.25 27.2853 24.507 27.766 24.1267 27.9438C23.6634 28.1604 23.123 28.2498 22.625 28.2498H3.375C2.87699 28.2498 2.33665 28.1604 1.87332 27.9438C1.49301 27.766 0.75 27.2853 0.75 26.3569V16.7498H3.25Z",
    fill: "#00842F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.8e045185.svg";
export { ForwardRef as ReactComponent };